import React from "react";
import { Connect } from "./Connect";

const Header = () => {
  return (
    <div className="">
      <div className="px-5">
        <div
          className={`flex
          justify-between 
          sm:mx-0
        text-[#ffffff]
          items-center 
          py-[15px]`}
        >
          <img src="/logo.png" alt="logo" width={50} />
          <div className="  text-[#ffffff] text-center rounded-[4px]">
            <Connect />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
